// ==================== REFUND POLICY PAGE COMPONENT ====================

import React, { useEffect, useState } from "react";
import Footer from "./Footer.js";
import Headerpage from "./Header2.js";
import { getData, serverURL } from "../../../Services/Fetchnodeservices.js";
import {
  RefreshCw,
  Clock,
  CreditCard,
  Wallet,
  Package,
  Shield,
  Phone,
  Mail,
  AlertCircle,
  CheckCircle,
  FileText,
  Calendar,
  ArrowLeftRight,
  DollarSign,
  Receipt,
  ThumbsUp,
  HelpCircle,
} from "lucide-react";

const RefundPolicy = ({ isDark }) => {
  const [refundData, setRefundData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const t = isDark
    ? {
        bg: "#0a0c10",
        cardBg: "#141824",
        text: "#e2e8f0",
        textSecondary: "#94a3b8",
        border: "rgba(255,255,255,0.08)",
        heading: "#ffffff",
        code: "#1e293b",
        accent: "#10b981",
        accentLight: "#34d399",
      }
    : {
        bg: "#f8fafc",
        cardBg: "#ffffff",
        text: "#334155",
        textSecondary: "#64748b",
        border: "rgba(0,0,0,0.1)",
        heading: "#0f172a",
        code: "#f1f5f9",
        accent: "#10b981",
        accentLight: "#6ee7b7",
      };

  const fetchRefundPolicy = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getData("refundpolicy/refundpolicy");
      console.log("API Response:", response);

      if (response?.status && response?.data) {
        setRefundData(response.data);
          console.log("Image URL:", `${serverURL}/images/${refundData.page_thumbnail}`);
      } else {
        setError("Refund policy not found");
      }
    } catch (err) {
      console.error("Error fetching refund policy:", err);
      setError("Failed to load Refund Policy. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRefundPolicy();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  if (loading) {
    return (
      <div
        style={{
          fontFamily: "'Poppins', sans-serif",
          background: t.bg,
          minHeight: "100vh",
        }}
      >
        <Headerpage />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <div
              style={{
                width: "60px",
                height: "60px",
                border: `3px solid ${t.border}`,
                borderTopColor: t.accent,
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
                margin: "0 auto 20px",
              }}
            />
            <p style={{ color: t.textSecondary }}>Loading Refund Policy...</p>
            <style>{`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}</style>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          fontFamily: "'Poppins', sans-serif",
          background: t.bg,
          minHeight: "100vh",
        }}
      >
        <Headerpage />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
            padding: "20px",
          }}
        >
          <div
            style={{
              textAlign: "center",
              backgroundColor: t.cardBg,
              padding: "40px",
              borderRadius: "20px",
              border: `1px solid ${t.border}`,
              maxWidth: "500px",
            }}
          >
            <div
              style={{
                width: "80px",
                height: "80px",
                background: "#fee2e2",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 20px",
              }}
            >
              <AlertCircle size={40} color="#ef4444" />
            </div>
            <h2 style={{ color: t.heading, marginBottom: "12px" }}>
              Refund Policy Not Found
            </h2>
            <p style={{ color: t.textSecondary, marginBottom: "24px" }}>
              {error}
            </p>
            <button
              onClick={fetchRefundPolicy}
              style={{
                padding: "12px 24px",
                backgroundColor: t.accent,
                color: "white",
                border: "none",
                borderRadius: "12px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              Try Again
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <>
      <style>{`
        .refund-content {
          word-wrap: break-word;
        }
        .refund-content h1 {
          font-size: 2rem;
          margin-top: 1.5em;
          margin-bottom: 0.5em;
          color: ${t.heading};
          font-weight: 700;
        }
        .refund-content h2 {
          font-size: 1.5rem;
          margin-top: 1.5em;
          margin-bottom: 0.5em;
          color: ${t.heading};
          font-weight: 600;
          border-left: 4px solid ${t.accent};
          padding-left: 1rem;
        }
        .refund-content h3 {
          font-size: 1.25rem;
          margin-top: 1.2em;
          margin-bottom: 0.5em;
          color: ${t.heading};
          font-weight: 600;
        }
        .refund-content p {
          line-height: 1.8;
          margin-bottom: 1rem;
          color: ${t.text};
        }
        .refund-content ul,
        .refund-content ol {
          margin: 1rem 0;
          padding-left: 2rem;
          color: ${t.text};
        }
        .refund-content li {
          margin: 0.5rem 0;
          line-height: 1.7;
        }
        .refund-content hr {
          margin: 2rem 0;
          border: none;
          height: 1px;
          background: ${t.border};
        }
        .refund-content a {
          color: ${t.accent};
          text-decoration: none;
        }
        .refund-content a:hover {
          text-decoration: underline;
        }
        .refund-content strong {
          color: ${t.heading};
          font-weight: 600;
        }
        @media (max-width: 768px) {
          .refund-content h1 {
            font-size: 1.5rem;
          }
          .refund-content h2 {
            font-size: 1.25rem;
          }
        }
      `}</style>

      <div
        style={{
          fontFamily: "'Poppins', sans-serif",
          background: t.bg,
          minHeight: "100vh",
        }}
      >
        <Headerpage />

        {/* Hero Section */}
        <section
          style={{
            position: "relative",
            minHeight: "350px",
            padding: "60px 20px",
            textAlign: "center",
            background: `linear-gradient(135deg, #0b0417 0%, #160a2e 40%, ${t.accent} 100%)`,
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              position: "absolute",
              width: "300px",
              height: "300px",
              background: "rgba(16,185,129,0.15)",
              filter: "blur(60px)",
              borderRadius: "50%",
              top: "-150px",
              left: "-100px",
            }}
          />
          <div
            style={{
              position: "absolute",
              width: "250px",
              height: "250px",
              background: "rgba(16,185,129,0.12)",
              filter: "blur(50px)",
              borderRadius: "50%",
              bottom: "-100px",
              right: "-80px",
            }}
          />

          <div
            style={{
              position: "relative",
              zIndex: 2,
              maxWidth: "800px",
            }}
          >
            {refundData?.page_thumbnail && (
                
              <div style={{ marginBottom: "24px" }}>
              
                <img
                  src={`${serverURL}/images/${refundData.page_thumbnail}`}
                  alt={refundData.page_title}
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid white",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                  }}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              </div>
              
            )}

            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                background: "rgba(255,255,255,0.15)",
                backdropFilter: "blur(10px)",
                padding: "8px 20px",
                borderRadius: "40px",
                marginBottom: "24px",
              }}
            >
              <RefreshCw size={18} />
              <span style={{ fontSize: "14px" }}>Refund Policy</span>
            </div>

            <h1
              style={{
                fontSize: "clamp(36px, 6vw, 56px)",
                fontWeight: "700",
                marginBottom: "16px",
              }}
            >
              {refundData?.page_title || "Refund Policy"}
            </h1>

            <div
              style={{
                display: "flex",
                gap: "8px",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "14px",
                opacity: 0.9,
              }}
            >
              <Clock size={18} />
              <span>Last Updated: {formatDate(refundData?.updated_at)}</span>
            </div>
          </div>
        </section>

        {/* Main Content Section */}
        <section
          style={{
            padding: "60px 20px",
            position: "relative",
            zIndex: 10,
          }}
        >
          <div
            style={{
              maxWidth: "1100px",
              margin: "0 auto",
            }}
          >
            {/* Refund Features Cards */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                gap: "24px",
                marginBottom: "48px",
              }}
            >
              <div
                style={{
                  background: t.cardBg,
                  padding: "28px",
                  borderRadius: "20px",
                  border: `1px solid ${t.border}`,
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    width: "70px",
                    height: "70px",
                    background: `${t.accent}15`,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 16px",
                  }}
                >
                  <RefreshCw size={32} color={t.accent} />
                </div>
                <h3 style={{ color: t.heading, fontSize: "18px", marginBottom: "8px" }}>
                  Easy Returns
                </h3>
                <p style={{ color: t.textSecondary, fontSize: "13px" }}>
                  Return items within 7 days of delivery
                </p>
              </div>

              <div
                style={{
                  background: t.cardBg,
                  padding: "28px",
                  borderRadius: "20px",
                  border: `1px solid ${t.border}`,
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    width: "70px",
                    height: "70px",
                    background: `${t.accent}15`,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 16px",
                  }}
                >
                  <DollarSign size={32} color={t.accent} />
                </div>
                <h3 style={{ color: t.heading, fontSize: "18px", marginBottom: "8px" }}>
                  Full Refund
                </h3>
                <p style={{ color: t.textSecondary, fontSize: "13px" }}>
                  Get full refund on eligible items
                </p>
              </div>

              <div
                style={{
                  background: t.cardBg,
                  padding: "28px",
                  borderRadius: "20px",
                  border: `1px solid ${t.border}`,
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    width: "70px",
                    height: "70px",
                    background: `${t.accent}15`,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 16px",
                  }}
                >
                  <Clock size={32} color={t.accent} />
                </div>
                <h3 style={{ color: t.heading, fontSize: "18px", marginBottom: "8px" }}>
                  Quick Processing
                </h3>
                <p style={{ color: t.textSecondary, fontSize: "13px" }}>
                  Refunds processed within 5-7 business days
                </p>
              </div>
            </div>

            {/* Main Content Card */}
            <div
              style={{
                backgroundColor: t.cardBg,
                borderRadius: "28px",
                border: `1px solid ${t.border}`,
                overflow: "hidden",
                boxShadow: isDark
                  ? "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
                  : "0 25px 50px -12px rgba(0, 0, 0, 0.1)",
              }}
            >
              <div style={{ padding: "48px" }}>
                <div
                  className="refund-content"
                  dangerouslySetInnerHTML={{
                    __html: refundData?.page_description || "No content available",
                  }}
                />

                {/* Footer Info */}
                <div
                  style={{
                    marginTop: "48px",
                    paddingTop: "24px",
                    borderTop: `1px solid ${t.border}`,
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: "16px",
                    fontSize: "13px",
                    color: t.textSecondary,
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <FileText size={16} />
                    <span>Page ID: {refundData?.id}</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <Calendar size={16} />
                    <span>Created: {formatDate(refundData?.created_at)}</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <CheckCircle size={16} />
                    <span>Status: {refundData?.status === 1 ? "Active" : "Inactive"}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Return Process Steps */}
            <div
              style={{
                marginTop: "48px",
              }}
            >
              <h2
                style={{
                  color: t.heading,
                  fontSize: "28px",
                  marginBottom: "32px",
                  textAlign: "center",
                }}
              >
                Easy Return Process
              </h2>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                  gap: "24px",
                }}
              >
                <div
                  style={{
                    background: t.cardBg,
                    padding: "24px",
                    borderRadius: "20px",
                    border: `1px solid ${t.border}`,
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      background: `${t.accent}15`,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                      fontSize: "24px",
                      fontWeight: "bold",
                      color: t.accent,
                    }}
                  >
                    1
                  </div>
                  <h3 style={{ color: t.heading, fontSize: "16px", marginBottom: "8px" }}>
                    Contact Support
                  </h3>
                  <p style={{ color: t.textSecondary, fontSize: "13px" }}>
                    Call or email us to initiate return request
                  </p>
                </div>

                <div
                  style={{
                    background: t.cardBg,
                    padding: "24px",
                    borderRadius: "20px",
                    border: `1px solid ${t.border}`,
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      background: `${t.accent}15`,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                      fontSize: "24px",
                      fontWeight: "bold",
                      color: t.accent,
                    }}
                  >
                    2
                  </div>
                  <h3 style={{ color: t.heading, fontSize: "16px", marginBottom: "8px" }}>
                    Pack & Ship
                  </h3>
                  <p style={{ color: t.textSecondary, fontSize: "13px" }}>
                    Pack item securely and ship it back
                  </p>
                </div>

                <div
                  style={{
                    background: t.cardBg,
                    padding: "24px",
                    borderRadius: "20px",
                    border: `1px solid ${t.border}`,
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      background: `${t.accent}15`,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                      fontSize: "24px",
                      fontWeight: "bold",
                      color: t.accent,
                    }}
                  >
                    3
                  </div>
                  <h3 style={{ color: t.heading, fontSize: "16px", marginBottom: "8px" }}>
                    Get Refund
                  </h3>
                  <p style={{ color: t.textSecondary, fontSize: "13px" }}>
                    Receive refund to original payment method
                  </p>
                </div>
              </div>
            </div>

            {/* Need Help Section */}
            <div
              style={{
                background: `linear-gradient(135deg, ${t.accent}15, ${t.accent}08)`,
                borderRadius: "24px",
                padding: "40px",
                marginTop: "48px",
                textAlign: "center",
                border: `1px solid ${t.border}`,
              }}
            >
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  background: `${t.accent}20`,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                }}
              >
                <HelpCircle size={28} color={t.accent} />
              </div>
              <h3
                style={{
                  color: t.heading,
                  fontSize: "24px",
                  marginBottom: "12px",
                }}
              >
                Need Help With Your Refund?
              </h3>
              <p
                style={{
                  color: t.textSecondary,
                  marginBottom: "28px",
                  fontSize: "15px",
                }}
              >
                Our customer service team is here to assist you with returns and refunds
              </p>
              <div
                style={{
                  display: "flex",
                  gap: "16px",
                  justifyContent: "center",
                  flexWrap: "wrap",
                }}
              >
                <a
                  href="tel:+919200018690"
                  style={{
                    background: t.accent,
                    color: "white",
                    padding: "12px 28px",
                    borderRadius: "40px",
                    textDecoration: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    fontWeight: "500",
                  }}
                >
                  <Phone size={18} />
                  Call Now
                </a>
                <a
                  href="mailto:info@zaptodoor.com"
                  style={{
                    background: "transparent",
                    color: t.text,
                    padding: "12px 28px",
                    borderRadius: "40px",
                    textDecoration: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    border: `1px solid ${t.border}`,
                    fontWeight: "500",
                  }}
                >
                  <Mail size={18} />
                  Email Support
                </a>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default RefundPolicy;